export { default as default } from './KitKeyboardAccessoryView';
